import { render, staticRenderFns } from "./BulkUpdateProductsRelated.vue?vue&type=template&id=5e1090e6&"
import script from "./BulkUpdateProductsRelated.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateProductsRelated.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpdateProductsRelated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports